import { render, staticRenderFns } from "./LessonProcessPage.vue?vue&type=template&id=0050a3b8&scoped=true&"
import script from "./LessonProcessPage.vue?vue&type=script&lang=js&"
export * from "./LessonProcessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0050a3b8",
  null
  
)

export default component.exports